import routerOptions0 from "/builds/jctrans/tech/front/dashboard/serverside/server-era-h5-front/node_modules/.pnpm/nuxt@3.16.2_eslint@9.25.1_rollup@4.40.0_sass@1.87.0_stylelint@16.18.0_typescript@5.8.3_vite@6.3.2/node_modules/nuxt/dist/pages/runtime/router.options.js";
import routerOptions1 from "/builds/jctrans/tech/front/dashboard/serverside/server-era-h5-front/app/router.options.ts";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = routerOptions0.hashMode ?? false
export default {
...configRouterOptions,
...routerOptions0,
...routerOptions1,
}